import { httpClient } from './httpClient';

let apiBaseUrl = process.env.REACT_APP_API;

export const getScenarioByID = async uuidScenario => {
	return httpClient(`${apiBaseUrl}/scenarios/${uuidScenario}`);
};
